import React, { useEffect, useState } from 'react';
export function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 30);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <nav className={`fixed top-0 left-0 right-0 z-[1000] flex items-center justify-between px-7 py-[18px] transition-all duration-400 ease-in-out border-b ${scrolled ? 'bg-[#0a0c0b]/70 backdrop-blur-[14px] border-line' : 'bg-transparent border-transparent'}`} data-id="element-137">
      <a href="#top" className="flex items-center gap-[11px] font-bold tracking-[-0.02em] text-[1.06rem] z-[1002]" data-id="element-138">
        <span className="w-[11px] h-[11px] rounded-full bg-acid shadow-[0_0_16px_var(--acid)] animate-pulse-dot" data-id="element-139"></span>
        LEADS&nbsp;AND&nbsp;WIN{' '}
        <small className="text-ink-faint font-medium text-[0.62rem] tracking-[0.18em] ml-[2px]" data-id="element-140">
          SL
        </small>
      </a>

      <div className={`flex gap-[34px] items-center max-md:fixed max-md:inset-0 max-md:left-auto max-md:w-[78%] max-md:max-w-[340px] max-md:bg-bg-2 max-md:flex-col max-md:justify-center max-md:p-10 max-md:gap-[26px] max-md:border-l max-md:border-line max-md:items-start transition-transform duration-450 ease-[cubic-bezier(0.6,0,0.2,1)] ${menuOpen ? 'max-md:translate-x-0' : 'max-md:translate-x-[105%]'}`} data-id="element-141">
        <a href="#servicios" onClick={() => setMenuOpen(false)} className="text-[0.86rem] max-md:text-[1.3rem] text-ink-dim hover:text-ink transition-colors font-medium" data-id="element-142">
          Servicios
        </a>
        <a href="#metodo" onClick={() => setMenuOpen(false)} className="text-[0.86rem] max-md:text-[1.3rem] text-ink-dim hover:text-ink transition-colors font-medium" data-id="element-143">
          Método
        </a>
        <a href="#resultados" onClick={() => setMenuOpen(false)} className="text-[0.86rem] max-md:text-[1.3rem] text-ink-dim hover:text-ink transition-colors font-medium" data-id="element-144">
          Resultados
        </a>
        <a href="#porque" onClick={() => setMenuOpen(false)} className="text-[0.86rem] max-md:text-[1.3rem] text-ink-dim hover:text-ink transition-colors font-medium" data-id="element-145">
          Por qué
        </a>
        <a href="#contacto" onClick={() => setMenuOpen(false)} className="bg-acid text-[#0a0c0b] px-5 py-[11px] rounded-full font-bold text-[0.84rem] transition-all duration-250 hover:-translate-y-[2px] hover:shadow-[0_8px_28px_rgba(196,255,61,0.32)]" data-id="element-146">
          Auditoría gratis →
        </a>
      </div>

      <div className="hidden max-md:flex flex-col gap-[5px] cursor-pointer p-[6px] z-[1001]" onClick={() => setMenuOpen(!menuOpen)} data-id="element-147">
        <span className={`w-6 h-[2px] bg-ink transition-all duration-300 ${menuOpen ? 'rotate-45 translate-y-[7px]' : ''}`} data-id="element-148"></span>
        <span className={`w-6 h-[2px] bg-ink transition-all duration-300 ${menuOpen ? 'opacity-0' : ''}`} data-id="element-149"></span>
        <span className={`w-6 h-[2px] bg-ink transition-all duration-300 ${menuOpen ? '-rotate-45 -translate-y-[7px]' : ''}`} data-id="element-150"></span>
      </div>
    </nav>;
}